module.exports = __webpack_public_path__ + "static/img/05_click.046c99c4.png";